import * as React from "react";
export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 60 60" {...props}>
    <path d="M58 0L30 28.1 1.9 0 0 1.9 28 30 0 58.1 1.9 60 30 31.9 58 60l2-1.9L31.9 30 60 1.9 58 0z" />
  </svg>
);
